import { render, staticRenderFns } from "./locale-date.vue?vue&type=template&id=0fe63c61&"
import script from "./locale-date.vue?vue&type=script&lang=js&"
export * from "./locale-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports